
  import Vue from 'vue';
  import PopularCategoryCard from '@/components/PopularCategoryCard';
export default {
  components: {
    PopularCategoryCard
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.title,
        },
        {
          hid: 'twitter:title',
          property: 'twitter:title',
          content: this.title,
        },

        {
  hid: 'description',
  name: 'description',
  content: 'Explore the best of South Goa with unforgettable sightseeing experiences. From stunning beaches to historical landmarks, discover everything this vibrant region has to offer.',
},
{
  hid: 'og:description',
  property: 'og:description',
  content: 'Discover the top sightseeing spots in South Goa. From beautiful beaches to historic sites, explore the vibrant culture and scenic landscapes of this amazing region.',
},
{
  hid: 'twitter:description',
  property: 'twitter:description',
  content: 'Enjoy the best of South Goa sightseeing. Visit stunning beaches, historic landmarks, and vibrant local spots for a truly unforgettable experience.',
},

        {
          hid: 'keywords',
          name: 'keywords',
          content: 'south goa sightseeing package by bus, south goa sightseeing package by ac bus, south goa sightseeing package, south goa sightseeing package by car, south goa sightseeing package by car price, south goa sightseeing package by bus from madgaon',
        },
        
      ],
    };
  },

  components: {},
  data() {
    return {

      reasons: [
    {
      title: "Stunning Destinations",
      text: "Discover breathtaking views and hidden gems with the best sightseeing spots in Goa!",
    },
    {
      title: "Fun for Everyone",
      text: "Whether you're an adventure lover or prefer a relaxed tour, there's something for everyone!",
    },
    {
      title: "Local Guides",
      text: "Our experienced guides will take you to the top attractions and share fascinating insights.",
    },
    {
      title: "Easy Booking",
      text: "Book your perfect sightseeing tour effortlessly through the Goa App at great rates!",
    },
  ],

    
      title: 'South Goa Sightseeing - South Goa Sightseeing Package by Bus ',
    };
  },

  jsonld() {
  return {
    '@context': 'https://schema.org',
    '@graph': [
    {
                "@type": "ImageObject",
                "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2022-06-21T10%3A48%3A38.340Ztemple.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=D%2BZVB8%2FD9YupQJzDVHZVuiOEfEoPlxQDB03fUhKEtdf4eilds4mptLsD1%2BwyG%2FJqtw4XuEdbW%2FWLt741zzV6U9y2%2But1rbIXocTSaJkuQ3YiQpR1TTAQqkZgXaUtQ4L10Jt%2BabPbGpGUfQDpXXcYM6uEix6OCSqnXT%2FBE3vptOiTJ8qvLWPeeQJnoshX9js8nJkX3EreZfLkR9%2FfnzQtii0EWRbUZ%2Bf67iMIv6uPoRGmfSxTLa7JGGkx2Mfb3vU4FTBnNSyPf8wwADkkDyJzGXE1ViEGFFHZGBzL847nWATB5WwuCO9hpRhfKIsiGfVG5WesI2aVw7YwI49sdtZKxA%3D%3D',
                "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2022-06-21T10%3A48%3A38.340Ztemple.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=D%2BZVB8%2FD9YupQJzDVHZVuiOEfEoPlxQDB03fUhKEtdf4eilds4mptLsD1%2BwyG%2FJqtw4XuEdbW%2FWLt741zzV6U9y2%2But1rbIXocTSaJkuQ3YiQpR1TTAQqkZgXaUtQ4L10Jt%2BabPbGpGUfQDpXXcYM6uEix6OCSqnXT%2FBE3vptOiTJ8qvLWPeeQJnoshX9js8nJkX3EreZfLkR9%2FfnzQtii0EWRbUZ%2Bf67iMIv6uPoRGmfSxTLa7JGGkx2Mfb3vU4FTBnNSyPf8wwADkkDyJzGXE1ViEGFFHZGBzL847nWATB5WwuCO9hpRhfKIsiGfVG5WesI2aVw7YwI49sdtZKxA%3D%3D',
                "contentUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2022-06-21T10%3A48%3A38.340Ztemple.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=D%2BZVB8%2FD9YupQJzDVHZVuiOEfEoPlxQDB03fUhKEtdf4eilds4mptLsD1%2BwyG%2FJqtw4XuEdbW%2FWLt741zzV6U9y2%2But1rbIXocTSaJkuQ3YiQpR1TTAQqkZgXaUtQ4L10Jt%2BabPbGpGUfQDpXXcYM6uEix6OCSqnXT%2FBE3vptOiTJ8qvLWPeeQJnoshX9js8nJkX3EreZfLkR9%2FfnzQtii0EWRbUZ%2Bf67iMIv6uPoRGmfSxTLa7JGGkx2Mfb3vU4FTBnNSyPf8wwADkkDyJzGXE1ViEGFFHZGBzL847nWATB5WwuCO9hpRhfKIsiGfVG5WesI2aVw7YwI49sdtZKxA%3D%3D',
                "caption": 'Goa App',
                "inLanguage": "en-US",
                "width": 800,
                "height": 440
            }, 
            {
            "@type": "BlogPosting",
            "@id": `https://www.goa.app/south-goa-sightseeing-package-by-bus`,
                mainEntityOfPage: {
                    '@type': 'WebPage',
                    '@id': `https://www.goa.app/south-goa-sightseeing-package-by-bus`
                },
                "headline": 'Goa App',
                "name": 'Goa App',
                description: '',
                datePublished: '2024-10-26T20:14:36+00:00',
                dateModified: '2024-10-26T20:14:36+00:00',
                author: {
                    '@type': 'Person',
                    name: 'Goa App',
                    url: "https://goa.app"
                },
                publisher: {
                    '@type': 'Organization',
                    "@id": "https://goa.app",
                    name: 'Goa App',
                    logo: {
                        '@type': 'ImageObject',
                        url: 'https://goa.app/goa-app-logo.svg'
                    }
                },
                "image": {
                    "@type": "ImageObject",
                    "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2022-06-21T10%3A48%3A38.340Ztemple.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=D%2BZVB8%2FD9YupQJzDVHZVuiOEfEoPlxQDB03fUhKEtdf4eilds4mptLsD1%2BwyG%2FJqtw4XuEdbW%2FWLt741zzV6U9y2%2But1rbIXocTSaJkuQ3YiQpR1TTAQqkZgXaUtQ4L10Jt%2BabPbGpGUfQDpXXcYM6uEix6OCSqnXT%2FBE3vptOiTJ8qvLWPeeQJnoshX9js8nJkX3EreZfLkR9%2FfnzQtii0EWRbUZ%2Bf67iMIv6uPoRGmfSxTLa7JGGkx2Mfb3vU4FTBnNSyPf8wwADkkDyJzGXE1ViEGFFHZGBzL847nWATB5WwuCO9hpRhfKIsiGfVG5WesI2aVw7YwI49sdtZKxA%3D%3D',
                    "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2022-06-21T10%3A48%3A38.340Ztemple.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=D%2BZVB8%2FD9YupQJzDVHZVuiOEfEoPlxQDB03fUhKEtdf4eilds4mptLsD1%2BwyG%2FJqtw4XuEdbW%2FWLt741zzV6U9y2%2But1rbIXocTSaJkuQ3YiQpR1TTAQqkZgXaUtQ4L10Jt%2BabPbGpGUfQDpXXcYM6uEix6OCSqnXT%2FBE3vptOiTJ8qvLWPeeQJnoshX9js8nJkX3EreZfLkR9%2FfnzQtii0EWRbUZ%2Bf67iMIv6uPoRGmfSxTLa7JGGkx2Mfb3vU4FTBnNSyPf8wwADkkDyJzGXE1ViEGFFHZGBzL847nWATB5WwuCO9hpRhfKIsiGfVG5WesI2aVw7YwI49sdtZKxA%3D%3D',
                    "height": "440",
                    "width": "800"
                },
                "url": `https://www.goa.app/south-goa-sightseeing-package-by-bus`,
                "isPartOf": {
                    "@type": "Blog",
                    "@id": "https://www.goa.app/",
                    "name": "Goa App Blog",
                    "publisher": {
                        "@type": "Organization",
                        "@id": "https://goa.app",
                        "name": "Goa App"
                    }
                },
            },
            
            {
  "@type": "Product",
  "name": "South Goa Sightseeing Package by Bus - Book @ ₹399 Flat 33% Off",
  "description": "Experience the best sightseeing in South Goa, where stunning landscapes, vibrant culture, and iconic landmarks come together for an unforgettable journey filled with picturesque moments.",
  "image": "https://storage.googleapis.com/goa-app-12a91.appspot.com/2022-06-21T10%3A48%3A38.340Ztemple.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=D%2BZVB8%2FD9YupQJzDVHZVuiOEfEoPlxQDB03fUhKEtdf4eilds4mptLsD1%2BwyG%2FJqtw4XuEdbW%2FWLt741zzV6U9y2%2But1rbIXocTSaJkuQ3YiQpR1TTAQqkZgXaUtQ4L10Jt%2BabPbGpGUfQDpXXcYM6uEix6OCSqnXT%2FBE3vptOiTJ8qvLWPeeQJnoshX9js8nJkX3EreZfLkR9%2FfnzQtii0EWRbUZ%2Bf67iMIv6uPoRGmfSxTLa7JGGkx2Mfb3vU4FTBnNSyPf8wwADkkDyJzGXE1ViEGFFHZGBzL847nWATB5WwuCO9hpRhfKIsiGfVG5WesI2aVw7YwI49sdtZKxA%3D%3D",
  "review": {
    "@type": "Review",
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": "Goa App"
    }
  },
  "brand": {
    "@type": "Brand",
    "name": "Goa App"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "ratingCount": "89",
    "ratingValue": "5",
    "reviewCount": "44"
  },
  "offers": {
    "@type": "Offer",
    "price": "399",
    "priceValidUntil": "2025-12-31",
    "priceCurrency": "INR",
    "availability": "InStock",
    "seller": {
      "@type": "Organization",
      "name": "Goa App"
    }
  }
},

            {
        "@type": "WebPage",
        "@id": "https://www.goa.app/south-goa-sightseeing-package-by-bus",
        "url": "https://www.goa.app/south-goa-sightseeing-package-by-bus",
        "name": "South Goa Sightseeing Package by Bus",
        "isPartOf": {
            "@id": "https://www.goa.app/#website"
        },
        "primaryImageOfPage": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2022-06-21T10%3A48%3A38.340Ztemple.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=D%2BZVB8%2FD9YupQJzDVHZVuiOEfEoPlxQDB03fUhKEtdf4eilds4mptLsD1%2BwyG%2FJqtw4XuEdbW%2FWLt741zzV6U9y2%2But1rbIXocTSaJkuQ3YiQpR1TTAQqkZgXaUtQ4L10Jt%2BabPbGpGUfQDpXXcYM6uEix6OCSqnXT%2FBE3vptOiTJ8qvLWPeeQJnoshX9js8nJkX3EreZfLkR9%2FfnzQtii0EWRbUZ%2Bf67iMIv6uPoRGmfSxTLa7JGGkx2Mfb3vU4FTBnNSyPf8wwADkkDyJzGXE1ViEGFFHZGBzL847nWATB5WwuCO9hpRhfKIsiGfVG5WesI2aVw7YwI49sdtZKxA%3D%3D'
        },
        "image": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2022-06-21T10%3A48%3A38.340Ztemple.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=D%2BZVB8%2FD9YupQJzDVHZVuiOEfEoPlxQDB03fUhKEtdf4eilds4mptLsD1%2BwyG%2FJqtw4XuEdbW%2FWLt741zzV6U9y2%2But1rbIXocTSaJkuQ3YiQpR1TTAQqkZgXaUtQ4L10Jt%2BabPbGpGUfQDpXXcYM6uEix6OCSqnXT%2FBE3vptOiTJ8qvLWPeeQJnoshX9js8nJkX3EreZfLkR9%2FfnzQtii0EWRbUZ%2Bf67iMIv6uPoRGmfSxTLa7JGGkx2Mfb3vU4FTBnNSyPf8wwADkkDyJzGXE1ViEGFFHZGBzL847nWATB5WwuCO9hpRhfKIsiGfVG5WesI2aVw7YwI49sdtZKxA%3D%3D'
        },
        "thumbnailUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2022-06-21T10%3A48%3A38.340Ztemple.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=D%2BZVB8%2FD9YupQJzDVHZVuiOEfEoPlxQDB03fUhKEtdf4eilds4mptLsD1%2BwyG%2FJqtw4XuEdbW%2FWLt741zzV6U9y2%2But1rbIXocTSaJkuQ3YiQpR1TTAQqkZgXaUtQ4L10Jt%2BabPbGpGUfQDpXXcYM6uEix6OCSqnXT%2FBE3vptOiTJ8qvLWPeeQJnoshX9js8nJkX3EreZfLkR9%2FfnzQtii0EWRbUZ%2Bf67iMIv6uPoRGmfSxTLa7JGGkx2Mfb3vU4FTBnNSyPf8wwADkkDyJzGXE1ViEGFFHZGBzL847nWATB5WwuCO9hpRhfKIsiGfVG5WesI2aVw7YwI49sdtZKxA%3D%3D',
        "datePublished": "2024-10-26T20:14:36+00:00",
        "dateModified": "2024-10-26T20:14:36+00:00",
        "description": "South Goa sightseeing Tour offers breathtaking views of stunning beaches, vibrant culture, and scenic landscapes. It’s an ideal destination for travelers looking to explore beautiful sunsets, historic sites like Aguada Fort, and lush greenery, creating unforgettable memories along the way.",
        "breadcrumb": {
            "@id": "https://www.goa.app/south-goa-sightseeing-package-by-bus/#breadcrumb"
        },
        "inLanguage": "en-US",
        "potentialAction": [{
            "@type": "ReadAction",
            "target": ["https://www.goa.app/south-goa-sightseeing-package-by-bus"]
        }]
      },
      {
        "@type": "FAQPage",
  "mainEntity": [
  {
        "@type": "Question",
        "name": "What are the key attractions covered in the South Goa sightseeing package by bus?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "The South Goa sightseeing package by bus typically covers Colva Beach, Basilica of Bom Jesus, Se Cathedral, and Palolem Beach."
        }
    },
    {
        "@type": "Question",
        "name": "How much does a South Goa sightseeing bus tour cost?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "South Goa sightseeing bus tours generally start from ₹399, depending on the package and services included."
        }
    },
    {
        "@type": "Question",
        "name": "How long does a South Goa sightseeing bus tour last?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "Most South Goa sightseeing bus tours last a full day, usually around 8 to 9 hours, visiting multiple attractions."
        }
    },
    {
        "@type": "Question",
        "name": "Are guides included in the South Goa sightseeing bus package?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, most bus packages include a guide who shares information about the history and culture of South Goa."
        }
    },
    {
        "@type": "Question",
        "name": "What is the best time to book a South Goa sightseeing bus tour?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "The best time for sightseeing in South Goa is from November to February when the weather is cool and pleasant."
        }
    },
    {
        "@type": "Question",
        "name": "Can I customize a South Goa sightseeing bus package?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "Bus tours usually follow a fixed itinerary, but some operators may offer semi-customizable options with additional stops."
        }
    },
    {
        "@type": "Question",
        "name": "What should I bring on a South Goa sightseeing bus tour?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "It's advisable to bring water, sunscreen, comfortable footwear, and a hat as you'll be outdoors for much of the tour."
        }
    },
    {
        "@type": "Question",
        "name": "How do I book a South Goa sightseeing package by bus?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "You can book a South Goa sightseeing bus package through local operators or online platforms like the Goa App, which offers various options."
        }
    },
    {
        "@type": "Question",
        "name": "Is transportation included in the South Goa sightseeing bus package?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, the bus package includes transportation to all sightseeing spots in South Goa."
        }
    },
    {
        "@type": "Question",
        "name": "Are South Goa sightseeing bus tours suitable for families?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, these bus tours are family-friendly, and children can join. Some tours may offer discounts for kids."
        }
    }
        ]
      }
    ]
  };
},


};



  